module.exports = __webpack_public_path__ + "img/Cement 960x1080.a71e4e90.png";